module.exports = __webpack_public_path__ + "img/inspetction_typeTab_bg.e47710da.png";